import {controllers} from '@mintdata-wsp/wsp/controllers/WspControllers';
import * as classnames from 'classnames/bind';
import {observer} from 'mobx-react';
import * as React from 'react';

const styles = require('./SurfaceDrawingComponentFrame.less');
const cx = classnames.bind(styles);

@observer
export class SurfaceDrawingComponentFrame extends React.Component<any, any>
{
    public render():JSX.Element
    {
        const {surfaceDrawingComponent} = controllers.ui;

        const isDrawingComponentEnabled:boolean = surfaceDrawingComponent.isDrawingComponentEnabled();

        if( isDrawingComponentEnabled )
        {
            const bounds = surfaceDrawingComponent.getDrawingComponentBounds(true);

            if( bounds )
            {
                const {x, y, width, height} = bounds;

                return (
                    <div
                        className={cx('base')}
                        style={{
                            left: `${x}px`,
                            top: `${y}px`,
                            width: `${width}px`,
                            height: `${height}px`
                        }}
                    />
                );
            }
        }

        return null;
    }
}
